let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lMeFU")).then(() => parcelRequire('2CRmv'));